var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"aiproxy-provider-label"},[_c('aiproxy-provider-icon',{staticClass:"aiproxy-provider-label__icon",attrs:{"provider-key":_vm.providerKey,"size":_vm.iconSize}}),_c('span',{staticClass:"aiproxy-provider-label__text"},[_vm._v(_vm._s(_vm.displayLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }